import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Reviews = ({ data }) => {
  const videoRefs = useRef({});
  const [activeIndex, setActiveIndex] = useState(null);

  const handlePlay = (index) => {
    const currentVideo = videoRefs.current[index];

    if (!currentVideo) return;

    // pause all videos
    Object.values(videoRefs.current).forEach((video) => {
      if (video) {
        video.pause();
        video.muted = true;
      }
    });

    // play selected
    currentVideo.muted = false;
    currentVideo.play();

    setActiveIndex(index);
  };

  return (
    <section className="mrv-methodology-section py-5">
      <div className="container">
        <div className="text-center mb-4">
          <span className="mrv-subtitle">Our Teaching Methodology</span>
          <h2 className="mrv-title">
            Learn Through Modern & Practical Methods
          </h2>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={14}
          observer={true}
          observeParents={true}
          observeSlideChildren={true}
          resizeObserver={false}
          pagination={{ clickable: true }}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 1.3 },
            576: { slidesPerView: 2.4 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {data?.map((item, index) => {
            const isVideo =
              item?.video &&
              (item.video.includes(".mp4") ||
                item.video.includes("youtube") ||
                item.video.includes("youtu.be"));

            return (
              <SwiperSlide key={index}>
                <div className="mrv-testimonial-card mrv-testimonial-video-card">
                  <div className="mrv-testimonial-media">
                    {isVideo ? (
                      item.video.includes("youtube") ||
                      item.video.includes("youtu.be") ? (
                        <iframe
                          src={item.video}
                          title={item?.title}
                          allowFullScreen
                        />
                      ) : (
                        <>
                          <video
                            ref={(el) => (videoRefs.current[index] = el)}
                            src={item.video}
                            loop
                            playsInline
                            controls
                            muted
                          />

                          {/* PLAY BUTTON */}
                          {activeIndex !== index && (
                            <div
                              className="play-overlay"
                              onClick={() => handlePlay(index)}
                            >
                              <div className="play-btn">▶</div>
                            </div>
                          )}
                        </>
                      )
                    ) : (
                      <img
                        src={item?.image}
                        alt={item?.title}
                        className="img-fluid"
                        loading="lazy"
                      />
                    )}

                    <div className="mrv-testimonial-overlay">
                      {item?.name && <h4>{item?.name}</h4>}
                      {item?.title && <span>{item?.title}</span>}
                      {item?.description && (
                        <p
                          className="mrv-text mb-3"
                          dangerouslySetInnerHTML={{
                            __html: item?.description || "",
                          }}
                        ></p>
                      )}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Reviews;
